import React from 'react'

const GptMovieSuggestions = () => {
  return (
    <div>
      
    </div>
  )
}

export default GptMovieSuggestions;
